import { createCrudPage } from './factories/crud-page.js';

const basePath = '/users-admin';

export default createCrudPage({
  title: 'Users',
  basePath,
  columns: [
    { key: 'first_name', label: 'First Name', sortable: true },
    { key: 'last_name', label: 'Last Name', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'role_name', label: 'Role', sortable: true },
    { key: 'country_name', label: 'Default Country', sortable: true },
    { key: 'countries_access', label: 'Countries Access' },
    { key: 'active', label: 'Active', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'last_login_timestamp', label: 'Last Login', sortable: true },
  ],
  fields: [
    { key: 'first_name', label: 'First Name', type: 'text', required: true },
    { key: 'last_name', label: 'Last Name', type: 'text', required: true },
    { key: 'email', label: 'Email', type: 'text', required: true },
    { key: 'role', label: 'Role', type: 'async-select',
      optionsUrl: '/users-roles/options' },
    { key: 'default_country', label: 'Default country', type: 'async-select',
      optionsUrl: '/countries/options' },
    { key: 'countries_access', label: 'Countries Access', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/countries/options',
      fieldInfo: 'All countries user has access in. These countries will be used to create initial user access.' },
    { key: 'countries_admin', label: 'Countries Administrate', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/countries/options',
      dependsOn: ['role'],
      visible: (v) => v.role == 1 || v.role == 2,
      fieldInfo: 'All countries user administrate.' },
    { key: 'active', label: 'Active', type: 'radio',
      options: [
        { value: '0', label: 'No' },
        { value: '1', label: 'Yes' },
      ],
      defaultValue: '1' },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
    { key: 'invite', label: 'Invite', icon: 'envelope',
      confirm: 'Do you want to invite this user to the platform?' },
    { key: 'grantAccess', label: 'Grant Access', icon: 'userPlus',
      confirm: 'Do you want to grant access for this user to the platform?' },
  ],
  customActions: (ctx) => ({
    invite: async (row) => {
      const email = String(row?.email ?? '').trim();
      if (!email) return;
      await ctx.services.apiClient.post('/users-admin/invite', {
        user_email: email,
        country: row.default_country,
      }, { signal: ctx.services.signal });
      ctx.grid.refresh();
    },
    grantAccess: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.post('/users-admin/grant-access', {
        user: id,
        role: row.role,
        countries: row.countries_access,
        defaultCountry: row.default_country,
      }, { signal: ctx.services.signal });
      ctx.grid.refresh();
    },
  }),
  defaultSort: { field: 'last_name', dir: 'asc' },
});
